import { render, staticRenderFns } from "./RPActionRecord.vue?vue&type=template&id=187e7cdc"
import script from "./RPActionRecord.vue?vue&type=script&lang=js"
export * from "./RPActionRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports